var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeSwitcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6534 16.7375C19.8623 16.4008 19.5771 15.99 19.181 15.9978C19.1208 15.999 19.0605 15.9996 19 15.9996C14.0294 15.9996 10 11.9702 10 6.99962C10 5.9145 10.192 4.87424 10.544 3.91096C10.6799 3.53885 10.3843 3.13534 9.998 3.2231C5.99102 4.13329 3 7.71716 3 11.9996C3 16.9702 7.02944 20.9996 12 20.9996C15.2321 20.9996 18.0663 19.2959 19.6534 16.7375Z",
    stroke: "#000536",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeSwitcher);
export default __webpack_public_path__ + "static/media/modeSwitcher.b53f938f0b936c5b786dddb4ed580060.svg";
export { ForwardRef as ReactComponent };